import React from "react";
import { BRAND } from "@/data/brand";

/**
 * Massive AG monogram with concentric circle rings — used as architectural element.
 * Sizes: 'hero' (huge backdrop), 'large', 'medium', 'small'
 */
export const ConcentricMonogram = ({
  size = 480,
  className = "",
  variant = "gold", // 'gold' | 'white' | 'ghost'
  showRings = true,
  rotateRings = true,
  glowColor = "blue",
}) => {
  const glowColors = {
    blue: "rgba(0, 119, 255, 0.25)",
    gold: "rgba(198, 168, 107, 0.2)",
    none: "transparent",
  };

  const monogramSrc = BRAND.logoWhite;
  const monogramFilter = variant === "ghost"
    ? "grayscale(1) brightness(1.4) opacity(0.5)"
    : variant === "white"
    ? "brightness(1.05)"
    : undefined;

  return (
    <div
      className={`relative flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {/* Ambient glow */}
      <div
        className="absolute inset-0 rounded-full"
        style={{
          background: `radial-gradient(circle, ${glowColors[glowColor] || glowColors.blue} 0%, transparent 65%)`,
          filter: "blur(60px)",
        }}
      />

      {/* Concentric rings */}
      {showRings && (
        <>
          <div
            className={`absolute rounded-full border ${rotateRings ? "ring-rotate-slow" : ""}`}
            style={{
              width: "100%",
              height: "100%",
              borderColor: "rgba(198, 168, 107, 0.18)",
              borderWidth: 1,
            }}
          />
          <div
            className={`absolute rounded-full border ${rotateRings ? "ring-rotate-reverse" : ""}`}
            style={{
              width: "82%",
              height: "82%",
              borderColor: "rgba(0, 170, 255, 0.15)",
              borderWidth: 1,
            }}
          />
          <div
            className="absolute rounded-full border"
            style={{
              width: "62%",
              height: "62%",
              borderColor: "rgba(255, 255, 255, 0.06)",
              borderWidth: 1,
            }}
          />
        </>
      )}

      {/* Monogram */}
      <img
        src={monogramSrc}
        alt=""
        className="relative monogram-float"
        style={{
          width: "50%",
          height: "auto",
          objectFit: "contain",
          filter: monogramFilter,
          opacity: variant === "ghost" ? 0.3 : 0.95,
        }}
        draggable={false}
      />
    </div>
  );
};

export default ConcentricMonogram;
